/* UC-PS19 landing page: comparison slider + one-open-at-a-time FAQ. No dependencies. */
(function () {
  'use strict';

  // ----- Slider (scroll-snap based; arrows rewind at the ends like the original) -----
  document.querySelectorAll('[data-ucps19-slider]').forEach(function (root) {
    var track = root.querySelector('[data-track]');
    var slides = track.children;
    var dots = root.querySelectorAll('[data-dot]');
    var current = 0;

    function goTo(i) {
      var n = slides.length;
      i = (i + n) % n;
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      setActive(i);
    }
    function setActive(i) {
      current = i;
      dots.forEach(function (d, k) {
        if (k === i) d.setAttribute('aria-current', 'true');
        else d.removeAttribute('aria-current');
      });
    }

    root.querySelector('[data-prev]').addEventListener('click', function () { goTo(current - 1); });
    root.querySelector('[data-next]').addEventListener('click', function () { goTo(current + 1); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { goTo(parseInt(d.getAttribute('data-dot'), 10)); });
    });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
    });

    // Keep dots in sync when the user swipes.
    var t;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var w = slides[0].getBoundingClientRect().width || 1;
        setActive(Math.round(track.scrollLeft / (w + 32)));
      }, 60);
    }, { passive: true });
  });

  // ----- FAQ: only one answer open at a time -----
  // Modern browsers do this natively via <details name="...">; this covers older ones.
  var items = document.querySelectorAll('.ucps19-faq__item');
  items.forEach(function (item) {
    item.addEventListener('toggle', function () {
      if (!item.open) return;
      items.forEach(function (other) { if (other !== item && other.open) other.open = false; });
    });
  });
})();
